import { useTranslator } from "../../i18n/context.js";
import { renderElement } from "../../utils/use-render.js";
import { useDialogContext } from "../dialog/context.js";
import { useErrorDialogContext } from "./context.js";
import { resolveErrorDialogDescription } from "@videojs/core";
import { translateText } from "@videojs/core/i18n";
import { forwardRef } from "react";
//#region src/ui/error-dialog/description.tsx
/** Renders the localized playback error message, or authored children when provided. */
const ErrorDialogDescription = forwardRef(function ErrorDialogDescription({ render, className, style, children, ...elementProps }, forwardedRef) {
	const t = useTranslator();
	const { state, stateAttrMap } = useDialogContext();
	const { lastError } = useErrorDialogContext();
	const description = resolveErrorDialogDescription(lastError);
	const content = children ?? translateText(description, t);
	return renderElement("p", {
		render,
		className,
		style
	}, {
		state,
		stateAttrMap,
		ref: forwardedRef,
		props: [{
			id: state.descriptionId,
			children: content
		}, elementProps]
	});
});
//#endregion
export { ErrorDialogDescription };

//# sourceMappingURL=description.js.map